import { useBreakpointValue } from '@chakra-ui/react';
import type { StatsMetricValue } from '@ui/hooks/stats/types';
import { formatNumber } from '@ui/utils/format';
import { format } from 'date-fns';
import { useMemo } from 'react';

import type {
  SimpleLineChartProps,
  SimpleLineChartSeries,
} from '../SimpleLineChart';
import { SimpleLineChart } from '../SimpleLineChart';
import StatsChartTitle from './StatsChartTitle';
import { useChartDefaultColorList } from './utils';

export type StatsSimpleLineChartProps = Partial<SimpleLineChartProps> & {
  values: Record<string, StatsMetricValue[] | undefined>;
  title: string;
};
export const StatsSimpleLineChart = ({
  values,
  title,
  ...props
}: StatsSimpleLineChartProps) => {
  const height = useBreakpointValue({ base: 155, desktop: 210 });
  const colors = useChartDefaultColorList();

  const series: SimpleLineChartSeries = useMemo(() => {
    const keys = Object.keys(values);

    return keys.map((key, i) => ({
      label: key,
      color: colors[i],
      data: (values[key] ?? []).map((val) => ({
        y: val.value,
        name: format(Number(val.timestamp) * 1000, 'yyyy - MM - dd'),
        key,
      })),
    }));
  }, [colors, values]);

  return (
    <SimpleLineChart
      title={<StatsChartTitle text={title} />}
      height={height}
      {...props}
      series={series}
      tooltipFormatter={({ y, key }) => {
        return `${key} ${formatNumber(y, 3, true, true)}`;
      }}
    />
  );
};
